import React from 'react';

export default function LoadingPage() {
  return (
    <div style={{display: 'flex', width: '100vw', height: '100vh', justifyContent: 'center', alignItems: 'center'}}>
      <p className='text-xl font-medium mx-7'>Loading...</p>
    </div>
  )
}